import React from "react";
import Layout from "../Layout/Layout";
import EditPortfolio from "../Componets/EditPortfolio";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useEffect } from "react";
import styled from "styled-components";

const EditPortfolioPage = () => {
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);

  return (
    <Layout>
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Root>
          <EditPortfolio />
        </Root>
      </div>
    </Layout>
  );
};

const Root = styled.div`
  min-height: 100vh;
  height: auto;
  display: flex;
  width: 100%;
  max-width: 100vw;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
`;

export default EditPortfolioPage;
